import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header";
import { useAuth } from "../hooks/AuthContext";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";

const { Sider } = Layout;

const RouteAtendente = ({ customContent }) => {
  const user = useAuth();

  useEffect(() => {
    let type = "";
    if (user.user) {
      type = user.user.type;
    }

    if (!type) {
      window.location.assign("/login");
    } else {
      if (type != "atendente") {
        if (type == "tecnico") {
          window.location.assign("/tecnico/home");
        } else {
          if (type == "cliente") {
            window.location.assign("/cliente/home");
          } else {
            window.location.assign("/admin/home");
          }
        }
      }
    }
  }, []);

  let type = "";
  if (user.user) {
    type = user.user.type;
  }

  return type == "atendente" ? (
    <Layout>
      <Header sidebar={false} />
      <Layout>
        <Content className="content" style={customContent || {}}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  ) : (
    <></>
  );
};
export default RouteAtendente;
